<template>
    <div>
        <div v-if="loaded && workshop">
            <o-card :enable-back="true" :title="workshop.title" class="col-lg-8 d-block">
                <table class="table-responsive table-borderless py-3">
                    <tr>
                        <td width="48%">{{ $t('medtastic.speaker') }}</td>
                        <td>{{ workshop.speaker }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('core.date') }}</td>
                        <td>{{ workshop.date|formatDate }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('medtastic.location') }}</td>
                        <td>{{ workshop.location }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('medtastic.time') }}</td>
                        <td>{{ workshop.time|formatTimeString }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('medtastic.credits') }}</td>
                        <td>{{ workshop.credits }}</td>
                    </tr>
                    <tr v-if="workshop.signup_active">
                        <td>{{ $t('medtastic.registration_link') }}</td>
                        <td>
                            <a :href="registrationLink">{{registrationLink}}</a>
                        </td>
                    </tr>
                    <tr v-if="workshop.pdf_document">
                        <td>{{ $t('medtastic.workshop_details') }}</td>
                        <td>
                            <o-button variant="dark" @click="downloadPDF(workshop)">
                                {{ $t('medtastic.download_pdf') }}
                            </o-button>
                        </td>
                    </tr>
                </table>
                <p class="pre-formatted" v-html="workshop.description"></p>
            </o-card>

            <template v-if="workshop.signup_hint">
                <br>
                
                <o-card class="col-lg-8 mt-2">
                    <div v-html="workshop.signup_hint"></div>
                </o-card>
            </template>

            <template v-if="workshop.signup_active">
                <br>

                <o-card :title="$t('medtastic.registration')" class="col-lg-8 mt-2" id="registration">
                    <form @keydown="form.onKeydown($event)" @submit.prevent="registration" class="my-3 ortic-form-horizontal">
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('core.title') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('title') }" class="form-control" name="title"
                                       type="text" v-model="form.title">
                                <has-error :form="form" field="title"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('core.first_name') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('first_name') }" class="form-control"
                                       name="first_name" type="text" v-model="form.first_name">
                                <has-error :form="form" field="first_name"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('core.last_name') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('last_name') }" class="form-control"
                                       name="last_name" type="text" v-model="form.last_name">
                                <has-error :form="form" field="last_name"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('medtastic.institution') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('institution') }" class="form-control"
                                       name="institution" type="text" v-model="form.institution">
                                <has-error :form="form" field="institution"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('medtastic.institution_address') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('institution_address') }" class="form-control"
                                       name="institution_address" type="text" v-model="form.institution_address">
                                <has-error :form="form" field="institution_address"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('medtastic.city') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('city') }" class="form-control" name="city"
                                       type="text" v-model="form.city">
                                <has-error :form="form" field="city"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('medtastic.postal_code') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('postal_code') }" class="form-control"
                                       name="postal_code" type="text" v-model="form.postal_code">
                                <has-error :form="form" field="postal_code"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('core.email') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('email') }" class="form-control" name="email"
                                       type="text" v-model="form.email">
                                <has-error :form="form" field="email"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('medtastic.confirm_email') }}</label>
                            <div class="col-md-9">
                                <input :class="{ 'is-invalid': form.errors.has('confirm_email') }" class="form-control"
                                       name="confirm_email" type="text" v-model="form.confirm_email">
                                <has-error :form="form" field="confirm_email"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3">{{ $t('core.language') }}</label>
                            <div class="col-md-9">
                                <b-form-select :options="workshop_locale" v-model="form.language"
                                               :class="{ 'is-invalid': form.errors.has('language') }">
                                </b-form-select>
                                <has-error :form="form" field="language"></has-error>
                            </div>
                        </div>

                      <div class="form-group">
                        <label class="col-md-3"></label>
                        <div class="col-md-9">
                          <b-form-checkbox v-model="form.terms_conditions"  class="widelabel"
                                           :class="{ 'is-invalid': form.errors.has('terms_conditions') }">
                            {{ $t('medtastic.agree_to_terms_conditions') }} (<span
                              @click.prevent="$bvModal.show('tc-modal')">{{
                              $t('medtastic.show_terms_conditions')
                            }}</span>)
                          </b-form-checkbox>
                          <has-error :form="form" field="terms_conditions"></has-error>

                          <b-modal id="tc-modal" :title="$t('medtastic.terms_conditions')" size="xl" ok-only>
                            <div v-if="!workshop.agb" class="pre-formatted" v-html="$t('medtastic.terms_conditions_content')">
                            </div>
                            <div v-else class="pre-formatted">
                              <div v-html="workshop.agb"></div>
                            </div>
                          </b-modal>
                        </div>
                      </div>

                        <div class="form-group">
                            <div class="col-md-9 offset-md-3">
                                <o-button :loading="form.busy" variant="dark">
                                    {{ $t('core.register') }}
                                </o-button>
                            </div>
                        </div>
                    </form>
                </o-card>
            </template>
        </div>
        <div v-if="loaded && !workshop">
            <o-card :shadow="false" :title="$t('core.page_not_found')" class="col-lg-8">
                <router-link to="/" class="btn btn-primary">
                    {{ $t('medtastic.back_to_home') }}
                </router-link>
            </o-card>
        </div>
        <div v-if="!loaded">
            <div class="btn-loading">&nbsp;<br>&nbsp;<br>&nbsp;</div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import Form from 'vform'

  export default {
    layout: 'user',
    data () {
      return {
        loaded: false,
        workshop: null,
        workshop_locale: window.config.workshop_locale,
        form: new Form({
          workshop_id: null,
          title: '',
          first_name: '',
          last_name: '',
          institution: '',
          institution_address: '',
          city: '',
          postal_code: '',
          email: '',
          confirm_email: '',
          language: '',
          terms_conditions: false
        }),
        registered: false
      }
    },
    mounted () {
      this.workshopDetail()
    },
    computed: {
      registrationLink() {
        return window.location.href
      }
    },
    methods: {
      workshopDetail: function () {
        axios.get('/api/medtastic/workshops/public?filter%5Bid%5D=' + this.$route.params.id)
          .then((response) => {
            this.workshop = response.data.data[0]
            this.form.workshop_id = this.workshop.id
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
      },
      async registration () {
        await this.form.post('/api/medtastic/workshop_registrations/register')

        this.$router.push({ name: 'medtastic.event_thanks' })
      },
      downloadPDF (workshop) {
        var fileName = workshop.pdf_document['name']
        axios.post('/api/medtastic/workshop/downloadPDF', {id:workshop.id}, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(
            response.data,
            fileName,
            'application/pdf'
          )
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>
